const menuButton = document.querySelector(".kids-menu-button");
const menu = document.querySelector(".kids-menu");
const closeButton = document.querySelector(".kids-menu-close");

menuButton.addEventListener("click", () => {
  menu.style.display = "flex";
  menuButton.style.display = "none";
});

function closeMenu() {
  menu.style.display = "none";
  menuButton.style.display = "block";
}

closeButton.addEventListener("click", closeMenu);

// 背景をクリックしたら閉じる
menu.addEventListener("click", (e) => {
  if (e.target === menu) {
    closeMenu();
  }
});